import React, { useState } from 'react';
import { formatDollarsWithCents } from '../../shared/givingHelpers';

// Givebutter-style fee summary: shows the gift amount prominently, the
// processing fee on a line below, and a "Change" link that expands an
// explanation plus the "I want to cover fees" checkbox. When the donor opts
// out, the fee line is struck through (it is no longer added to the charge).
const DonationFeeSummary = ({
  amount,
  processingFee,
  coverProcessing,
  setCoverProcessing,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="gc-fee-summary">
      <div className="gc-fee-amount">{formatDollarsWithCents(amount)}</div>

      <div className="gc-fee-line">
        <span className={`gc-fee-text${coverProcessing ? '' : ' gc-fee-text--declined'}`}>
          + {formatDollarsWithCents(processingFee)} processing fee
        </span>
        <button
          type="button"
          className="gc-fee-toggle"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Done' : 'Change'}
        </button>
      </div>

      {expanded && (
        <div className="gc-fee-panel">
          <p className="gc-fee-panel-text">
            Payment processors take a cut of each transaction. You have the
            option to cover these fees so 100% of your gift reaches the campaign.
          </p>
          <div className="gc-checkbox-row" onClick={() => setCoverProcessing(!coverProcessing)}>
            <div className={`gc-checkbox${coverProcessing ? ' gc-checkbox--checked' : ''}`}>
              {coverProcessing && (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2.5 6L5 8.5L9.5 3.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </div>
            <span className="gc-checkbox-label-text">I want to cover fees</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default DonationFeeSummary;
